import { createMeasurement, type MeasurementProps } from './createMeasurement';

export type EmissionProps = MeasurementProps<'emission'>;

/** Tailpipe output over distance, as grams per kilometre or pounds per mile. */
const Emission = createMeasurement('emission', 'Emission');

export default Emission;
